
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sostenibilita",
      function () {
        return require("private-next-pages/sostenibilita/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sostenibilita"])
      });
    }
  